import { Select } from "antd";
import { FC } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { RootState } from "../store/rootReducer";

interface IProps {
  campusCode: string;
  setCampusCode: (campusCode: string) => void;
}

const SelectCampusForHq: FC<IProps> = ({
  campusCode,
  setCampusCode,
}) => {
  const { t } = useTranslation();
  const { campusData } = useSelector((state: RootState) => state.campusData);

  return (
    <Select
      className="w-100"
      placeholder={t('common.menu.campus')}
      value={campusCode}
      onChange={value => setCampusCode(value)}
    >
      <Select.Option value="">{t('common.text.all')}</Select.Option>
      {campusData?.map((item) => (
        <Select.Option
          key={item.campusCode}
          value={item.campusCode}
        >
          {item.campusKorName}
        </Select.Option>
      ))}
    </Select>
  );
}

export default SelectCampusForHq;
